import { getKeys } from '../../adapters/utils';
import { SD_STATUS } from '../../consts';
import { get } from '../../utils/get';
export var IDs = {
    TOTAL_PAGES: 'paginated-component.total-pages',
    CURRENT_PAGE: 'paginated-component.current-page',
    QUERY_PARAM: 'paginated-component.query-param',
};
var SchemaTypes = {};
var userVisible = [];
export default {
    IDs: IDs,
    SchemaTypes: SchemaTypes,
    getData: function (item) {
        var _a;
        return _a = {},
            _a[IDs.CURRENT_PAGE] = parseInt(get(item, 'pagination.currentPage'), 10),
            _a[IDs.TOTAL_PAGES] = parseInt(get(item, 'pagination.totalPages'), 10),
            _a[IDs.QUERY_PARAM] = 'page',
            _a;
    },
    getSdStatus: function () { return SD_STATUS.DOES_NOT_EXIST; },
    getKeys: function () { return getKeys(IDs, userVisible); },
    getSdKeys: function () { return []; },
};
